// Compact projection of prep/markup-v2-data-collection-20260722.json.
// Only evidence required by the core creator explorer is shipped to the browser.
export const coreSmartHomeBrandAudit = [
  {
    name: 'こにたく / nikostyle',
    brands: ['SwitchBot', 'CANDY HOUSE／SESAME', 'Aqara'],
    peakViews: 233338,
    evidenceUrl: 'https://www.youtube.com/watch?v=GbrwhJDULWk',
    evidenceTitle: '5,000円以下から始めるスマートホーム機器紹介',
  },
  { name: 'anchovy｜ガジェット×便利アイテム', brands: ['SwitchBot'] },
  { name: 'Ohouse オーハウス | インテリア・家具', brands: ['Midea'] },
  {
    name: 'カズチャンネル/Kazu Channel',
    brands: ['SADIOT LOCK', 'SwitchBot', 'Roborock', 'Google Nest', 'Xiaomi', 'Dreame', 'Aqara'],
    peakViews: 601069,
    evidenceUrl: 'https://www.youtube.com/watch?v=hDf6B5jIv9I',
    evidenceTitle: '賃貸対応スマートロック設置コンテンツ',
  },
  {
    name: 'ツヨシ | techyou',
    brands: ['SwitchBot'],
    peakViews: 50969,
    evidenceUrl: 'https://www.youtube.com/watch?v=v2OvB0JCFUw',
    evidenceTitle: 'SwitchBot Smart Daily Station 紹介',
  },
  { name: '自動化らぼ@東北大博士の無駄遣い', brands: ['SwitchBot'] },
  { name: 'ものこと⌇ガジェットに囲まれた暮らし', brands: ['SwitchBot'] },
  { name: 'しば夫婦｜ふたり暮らしのベストバイ', brands: ['Roborock'] },
  {
    name: 'マメ',
    brands: ['SwitchBot', 'Dreame', 'Aqara', 'Eufy', 'Roborock'],
    peakViews: 273568,
    evidenceUrl: 'https://www.youtube.com/watch?v=5wPDRvmoIGk',
    evidenceTitle: 'SwitchBot自動化アイデア14選',
  },
  { name: 'はと｜ズル賢い暮らし革命', brands: ['Dreame'] },
  {
    name: 'Apple Watch Journal',
    brands: ['SwitchBot'],
    peakViews: 66380,
    evidenceUrl: 'https://www.youtube.com/watch?v=4eP4DnGFYsE',
    evidenceTitle: 'SwitchBot Hub 3 徹底解説',
  },
  { name: 'Yutta', brands: ['Xiaomi'] },
  { name: 'apartment301 ｜賃貸リノベと持たない暮らし', brands: ['Philips Hue'] },
  { name: 'すい｜賃貸×快適な暮らし', brands: ['Dreame'] },
  {
    name: 'ワタナベカズマサ',
    brands: ['Xiaomi', 'Dreame', 'Eufy', 'Aqara', 'Roborock'],
    peakViews: 762854,
    evidenceUrl: 'https://www.youtube.com/watch?v=8oIxsKZaEDA',
    evidenceTitle: 'Xiaomi 関連ブランドコンテンツ',
  },
  {
    name: 'よしお　プロ目線の暮らし家電とガジェット',
    brands: ['Eufy', 'SwitchBot', 'Roborock'],
    peakViews: 6789,
    evidenceUrl: 'https://www.youtube.com/watch?v=wDBb81gdkdQ',
    evidenceTitle: 'SwitchBot S10 ロボット掃除機紹介',
  },
  { name: 'ayumi┊ 建売×DIY×海外インテリア', brands: ['TP-Link', 'Dreame', 'Tapo'] },
]

